import React from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import Header from "../components/Header";

const AdminLogin = () => {
  const [params] = useSearchParams();
  const denied = params.get("denied");
  const error = params.get("error");

  const handleLogin = () => {
    /**
     * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
     */
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-warm-ivory">
      <Header cartItems={[]} onRemoveFromCart={() => {}} onUpdateQuantity={() => {}} />
      <section className="pt-40 md:pt-44 pb-20 px-6">
        <div className="container mx-auto max-w-lg">
          <Card className="border-stone-taupe/20">
            <CardHeader>
              <CardTitle className="text-3xl text-charcoal-ink">Studio Admin</CardTitle>
              <CardDescription className="text-stone-taupe">
                Sign in with your Google account to access orders, custom requests, and design details.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              {denied && (
                <div className="bg-red-50 border border-red-200 text-red-800 text-sm p-3 rounded-md">
                  This Google account is not authorized to view the studio dashboard.
                </div>
              )}
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-800 text-sm p-3 rounded-md">
                  Sign-in failed. Please try again.
                </div>
              )}
              <Button
                onClick={handleLogin}
                data-testid="admin-google-login-button"
                className="w-full bg-charcoal-ink hover:bg-charcoal-ink/90 text-warm-ivory py-6"
              >
                Continue with Google
              </Button>
              <p className="text-xs text-stone-taupe">
                Studio access is limited to allow-listed admin emails.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default AdminLogin;
